/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './header.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../social-share/social-share.component.ngfactory';
import * as import5 from '../../../../../app/shared/social-share/social-share.component';
import * as import6 from '../../../../../app/shared/decorator/header/header.component';
const styles_HeaderComponent:any[] = [import0.styles];
export const RenderType_HeaderComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_HeaderComponent,
  data: {}
}
);
export function View_HeaderComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),34,'div',[
      [
        'class',
        'container'
      ]
      ,
      [
        'id',
        'header'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),31,'div',[[
        'class',
        'row align-items-center no-gutters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-md'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'col-4 col-md-4'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'button',[
      [
        'class',
        'hamburger-button hamburger hamburger--arrow'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'hamburger-box'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'span',[[
        'class',
        'hamburger-inner hamburger-inner-custom'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'div',[
      [
        'class',
        'col-4 col-md-2'
      ]
      ,
      [
        'style',
        'text-align: center;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[[
        'routerLink',
        '/'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,20).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'src',
        '/images/logo/howmuch-understanding-money.png'
      ]
      ,
      [
        'style',
        'width: 150px; height: auto;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-1 col-md-3'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'col-1 col-md-2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'socialShare',([] as any[]),(null as any),(null as any),(null as any),import4.View_SocialShareComponent_0,import4.RenderType_SocialShareComponent)),
    import1.ɵdid(4767744,(null as any),0,import5.SocialShareComponent,[
      'isBrowser',
      import1.ElementRef,
      import1.Renderer2
    ]
      ,{isHeader: [
        0,
        'isHeader'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'col-md'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/';
    ck(v,20,0,currVal_2);
    const currVal_3:any = true;
    ck(v,29,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,20).target;
    const currVal_1:any = import1.ɵnov(v,20).href;
    ck(v,19,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'header',([] as any[]),(null as any),(null as any),(null as any),View_HeaderComponent_0,RenderType_HeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import6.HeaderComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const HeaderComponentNgFactory:import1.ComponentFactory<import6.HeaderComponent> = import1.ɵccf('header',import6.HeaderComponent,View_HeaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/decorator/header/header.component.ngfactory.ts